import { useRouteLoaderData } from "@remix-run/react";

import { useLabels } from "~/hooks/useLabels";
import { pathFor } from "~/utils/url";
import { QuizCard } from "~/components/quizCard/QuizCard";
import { RouteType } from "~/constants";
import { useUserContext } from "~/hooks/useUserContext";

import { ModuleIndexItem } from "./ModuleIndexItem";

import "./ModuleIndex.css";

import type { ModuleRouteLoaderData } from "../$class_.modules.$module/route";

export function ModuleIndex() {
  const data = useRouteLoaderData(
    "routes/$class_.modules.$module",
  ) as ModuleRouteLoaderData;

  const { currentUser } = useUserContext();

  const { t } = useLabels();

  const sessions = data.module.sessions?.nodes;

  return (
    <>
      <ol className="ModuleIndexItems" start={sessions?.[0].position ?? 1}>
        {sessions?.map((session) => {
          return (
            <li key={session.position}>
              <ModuleIndexItem session={session} />
            </li>
          );
        })}

        {data.module.quiz && (
          <li>
            <QuizCard
              artworkColor={data.module.class?.color.primary}
              href={pathFor(RouteType.QUIZ, {
                class: data.module.class?.slug!,
                quiz: String(data.module.quiz.position),
              })}
              meta={[t("common.quiz")]}
              nativeBehavior={
                currentUser ? "presentFullScreen" : "presentLogin"
              }
              nativeStencil={{
                propsJSON: "{}",
                type: "session",
              }}
              progress={
                data.module.quiz.user?.completedAt
                  ? 1
                  : (data.module.quiz.user?.progress ?? 0)
              }
              questionCount={data.module.quiz.questions.length}
              title={data.module.quiz.title}
            />
          </li>
        )}
      </ol>
    </>
  );
}
